import React, {useState, useEffect } from "react";
import { Input, Button, styled, Box, IconButton, FormControl, FormHelperText } from "@mui/material";
import InputBase from "@mui/material/InputBase";
//import { theme } from "material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import Select, { StylesConfig }  from "react-select";
import TableTestForm from "../form/TableTestForm.jsx";

export default function CMMForm (props) {
    

    const [data, setData] = useState(
        {
            title: "", description: "", image_url: ""
        }
    );

    const [errors, setErrors] = useState(
        {
            title: "", description: "", image_url: ""
        }
    );

    const handleChange = ({ currentTarget: input}) => {
        let newData = { ...data };
        console.log("input.name=" + input.name);
        console.log("input.value=" + input.value);
        newData[input.name] = input.value;
        setData(newData);
    }
    
    const [PicFile, setPicFile]=useState();

    const handleImageChange = (e) => {
        let newData = { ...data };
        newData["image_url"] = e.target.files[0];
        setData(newData);
        setPicFile(URL.createObjectURL(e.target.files[0]));
    }
    
    const doSubmit = (e) =>{
      let url="myapi/postMMVS"
      let headerContent={
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: data
      }
      //let body=data
      try{
      fetch(url, headerContent)
        .then( (response)=>response.json )
        .then( (data)=>console.log("data=" + data))
      }
      catch(Exception){
        console.log("Exception=" + Exception)
       }
    }

    const doSubmitData = (e) =>{
        console.log("data.title=" + data['title'])
        console.log("data.image_url=" + data['image_url'])
        console.log("data.description=" + data['description'])
        console.log("data=" + data)

        let APIURL="/myapi/postMMVS"
        let APIHeaderOptions={
           method: "POST",
           headers: { 'Content-Type':'application/json' },
           body: JSON.stringify(data)
        }
   
        fetch(APIURL, APIHeaderOptions)
        .then( (response)=> response.json )
        .then( (data)=>console.log("returned data=" + data) )
        
       }

    return(
        
        <div>
        
        <br />
        <input 
        type="file"
        name="image_url"
        accept="image/jpeg, image/png, image/gif"
        //value={data.title}
        //isInvalid={errors.title}
        onChange={(e) => {
            handleImageChange(e);
        }}
        sx={{
            width: "250px",
            height: "50px",
            border: "1px solid grey",
            borderRadius: "3px"
           }}
        />
        <br />
       <img src={PicFile}  width={350} height={200} />
        {errors.image_url && (
            <FormHelperText tooltip>
                {errors.image_url}
            </FormHelperText>
        )}
        <br />
        
        <FormControl 
        as="textarea"
        name="description"
        value={data.description}
        isInvalid={errors.description}
        onChange={(e) => {
            handleChange(e);
        }}
        sx={{
            border: "1px solid grey",
            borderRadius: "3px"
           }}
        />
        {errors.title && (
            <FormHelperText tooltip>
                {errors.description}
            </FormHelperText>
        )}
        <br />
        
        <FormControl 
        as="textarea"
        name="title"
        value={data.title}
        isInvalid={errors.title}
        onChange={(e) => {
            handleChange(e);
        }}
        sx={{
            border: "1px solid grey",
            borderRadius: "3px"
           }}
        placeholder="Title"
        />
        {errors.title && (
            <FormHelperText tooltip>
                {errors.title}
            </FormHelperText>
        )}
        <br />
        <Button
        variant="primary"
        type="submit"
        onClick={(e)=> doSubmitData(e)}
        sx={{
            border: "1px solid grey",
            borderRadius: "3px"
           }}
        >
            click
        </Button>

        </div>

    )
}
